// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__F0S2D","row":"Node_row__28y0Z","label":"Node_label__YRs4i","footer":"Node_footer__1g1om"};